import { render, staticRenderFns } from "./HomeOpenedTicketsStat.vue?vue&type=template&id=00f6d3c8&scoped=true"
import script from "./HomeOpenedTicketsStat.vue?vue&type=script&lang=js"
export * from "./HomeOpenedTicketsStat.vue?vue&type=script&lang=js"
import style0 from "./HomeOpenedTicketsStat.vue?vue&type=style&index=0&id=00f6d3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f6d3c8",
  null
  
)

export default component.exports